import { FC, useEffect, useState } from "react";
import { ReactComponent as TopArrow } from "../../../images/top-arrow.svg";
import cn from "classnames";
import styles from "./SortBy.module.sass";

export interface OptionInterface {
	name: string | null;
	text: string;
}

interface SortByPropsInterfase {
	selectedOption: OptionInterface;
	setSelectedOption: any;
	options: OptionInterface[];
}

const SortBy: FC<SortByPropsInterfase> = ({ options, selectedOption, setSelectedOption }) => {
	const [open, setOpen] = useState<boolean>(false);

	useEffect(() => {
		const hideSelect = () => setOpen(false);

		document.addEventListener("click", hideSelect);

		return () => {
			document.removeEventListener("click", hideSelect);
		};
	}, []);

	const handleOpen = () => {
		setOpen(!open);
	};

	const handleSelectOption = (option: OptionInterface) => {
		setSelectedOption(option);
		setOpen(false);
	};

	return (
		<div
			className={cn(styles.select, { [styles.selectActive]: open })}
			onClick={(e) => {
				e.stopPropagation();
				handleOpen();
			}}>
			<div className={styles.text}>{selectedOption.text}</div>
			{open && (
				<div className={styles.boxOptions} onClick={(e) => e.stopPropagation()}>
					{options.map((option, index) => (
						<div
							key={index}
							id={option.name || ""}
							className={cn(styles.option, {
								[styles.selectOption]: selectedOption.name === option.name,
							})}
							onClick={() => handleSelectOption(option)}>
							{option.text}
						</div>
					))}
				</div>
			)}
			<TopArrow className={cn(styles.icon, { [styles.active]: open })} />
		</div>
	);
};

export default SortBy;
